import ParallaxSection from './ParallaxSection';
export default ParallaxSection;
